import AvatarImg from "./avatar";
export default AvatarImg;



// WEBPACK FOOTER //
// ./src/model/avatar/index.js